import React, { useEffect, useState } from 'react';
import Header from '../Component/Header'
import Footer from '../Component/Footer'
// import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../assets/css/style.css';
import { EffectFade } from "swiper/modules";
import "swiper/css/effect-fade";
import { NavLink } from 'react-router-dom';


function Home() {
    const [, setServices] = useState([]); // State to store services
    const [, setLoading] = useState(true);
    const [, setError] = useState("");
    const [videoLinks, setVideoLinks] = useState([]);
    // const reelsContainerRef = useRef(null);

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/getcategories`);
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const result = await response.json();

                // Transform the fetched data to match your services structure
                const transformedData = result.data.map((item) => ({
                    id: item.id,
                    name: item.category,
                    image: `${item.categoryIcon}`, // Prepend the image URL from the environment variable
                }));

                setServices(transformedData);
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        fetchServices();
    }, []);

    const fetchVideos = async () => {
        const token = localStorage.getItem('authToken');
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/getvideos`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            const result = await res.json();
            setVideoLinks(result.videos || []);
        } catch (error) {
            console.error('Error fetching videos:', error);
        }
    };

    useEffect(() => {
        fetchVideos();
    }, []);


    const images = [
        "/img/Home/1.webp",
        "/img/Home/2.webp",
        "/img/Home/3.webp",
        "/img/Home/4.webp",
        "/img/Home/5.webp",
    ];

    useEffect(() => {
        const videos = document.querySelectorAll("video");
        videos.forEach((video) => {
            video.muted = true;

            const playPromise = video.play();

            if (playPromise && typeof playPromise.then === "function") {
                playPromise
                    .then(() => { })
                    .catch((error) => console.warn("Autoplay blocked:", error));
            }
        });
    }, [videoLinks]);

    return (
        <>

            {/* 🔥 WOW FIX ADDED HERE */}
            <style>{`
                .wow {
                    contain: layout style paint;
                    will-change: opacity, transform;
                }
            `}</style>

            <Header />
            <div style={{ height: "70px" }}></div>

            {/* Banner Section */}
            <div style={{ backgroundColor: "#FFFFFF", overflowX: "hidden" }}>
                <div className="hero-header py-5 mb-0 mt-5 mt-sm-0">
                    <Swiper
                        modules={[Autoplay, EffectFade]}
                        autoplay={{ delay: 4000, disableOnInteraction: false }}
                        loop={true}
                        speed={800}
                        effect="fade"
                        fadeEffect={{ crossFade: true }}
                        slidesPerView={1}
                        style={{ width: "100%", height: "calc(100vw / 2.37)", maxHeight: "631px" }}
                    >
                        {images.map((image, index) => (
                            <SwiperSlide key={index}>
                                <img
                                    src={image}
                                    alt={`Slide ${index + 1}`}
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>


                {/* What We Do Section */}
                <div
                    className="what-we-do-section"
                    style={{
                        backgroundColor: "#ffffff", // plain background
                        padding: "100px 20px",
                        position: "relative",
                        color: "#000",
                        textAlign: "center"
                    }}
                >
                    <div
                        className="container"
                        style={{
                            maxWidth: "900px",
                            margin: "0 auto"
                        }}
                    >

                        {/* Top Divider */}
                        <div className="elementor-divider">
                            <span
                                className="elementor-divider-separator"
                                style={{
                                    display: "block",
                                    borderTop: "1px solid rgba(0,0,0,0.3)",
                                    margin: "0 auto 20px",
                                    width: "60%"
                                }}
                            ></span>
                        </div>

                        {/* Title */}
                        <h2
                            className="what-we-do-title"
                            style={{
                                color: "#000",
                                fontSize: "42px",
                                fontWeight: 700,
                                marginBottom: "20px"
                            }}
                        >
                            What We Do ?
                        </h2>

                        {/* Bottom Divider */}
                        <div className="elementor-divider">
                            <span
                                className="elementor-divider-separator"
                                style={{
                                    display: "block",
                                    borderTop: "1px solid rgba(0,0,0,0.3)",
                                    margin: "20px auto",
                                    width: "60%"
                                }}
                            ></span>
                        </div>

                        {/* Description */}
                        <p
                            style={{
                                fontSize: "18px",
                                lineHeight: "1.7",
                                color: "rgba(0,0,0,0.75)"
                            }}
                        >
      We specialize in capturing the magic of love stories with creativity, passion, and cinematic artistry. From heartfelt pre-wedding moments to grand wedding celebrations, our work reflects emotion, connection, and timeless storytelling. With a blend of candid elegance and fine detailing, every photograph and film we create is crafted to preserve your most precious memories forever.
                        </p>
                    </div>
                </div>


                {/* Our Journey Section */}
                <div
                    className="our-journey-section"
                    style={{
                        backgroundImage: "url('/img/About/Journey.webp')",  // <-- Change to your desired background
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        padding: "100px 20px",
                        position: "relative",
                        color: "#fff"
                    }}
                >
                    {/* Black overlay for a professional cinematic look */}
                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            backgroundColor: "rgba(0,0,0,0.55)"
                        }}
                    ></div>

                    <div
                        className="container"
                        style={{
                            position: "relative",
                            zIndex: 2,
                            maxWidth: "900px",
                            textAlign: "center"
                        }}
                    >

                        {/* Top Divider */}
                        <div className="elementor-divider">
                            <span
                                className="elementor-divider-separator"
                                style={{
                                    display: "block",
                                    borderTop: "1px solid rgba(255,255,255,0.4)",
                                    margin: "0 auto 20px",
                                    width: "60%"
                                }}
                            ></span>
                        </div>

                        {/* Title */}
                        <h2
                            className="our-journey-title"
                            style={{
                                color: "#fff",
                                fontSize: "42px",
                                fontWeight: 700,
                                marginBottom: "20px"
                            }}
                        >
                            Our Journey
                        </h2>

                        {/* Bottom Divider */}
                        <div className="elementor-divider">
                            <span
                                className="elementor-divider-separator"
                                style={{
                                    display: "block",
                                    borderTop: "1px solid rgba(255,255,255,0.4)",
                                    margin: "20px auto",
                                    width: "60%"
                                }}
                            ></span>
                        </div>

                        {/* Description */}
                        <p
                            style={{
                                fontSize: "18px",
                                lineHeight: "1.7",
                                color: "rgba(255,255,255,0.85)"
                            }}
                        >
                            Our journey began with a simple belief that every love story deserves to be captured with honesty, beauty, and heart. Over the years, Well Captured Hub has grown from a passionate vision into a trusted name in wedding and pre-wedding photography, led by the creative expertise of Anil Pandey. With each couple we meet and every celebration we document, we continue to refine our craft, blending creativity with emotion to create memories that stand the test of time. What started as a dream has now become a legacy of capturing moments that live forever.
                        </p>
                    </div>
                </div>


            {/* About Owner Section */}
            <div
    className="container-xxl"
    style={{
        paddingTop: "90px",      // 👈 Change top gap here
        paddingBottom: "10px",   // 👈 Change bottom gap here
    }}
>
                <div className="container">
                    <div className="row g-5">

                        {/* Image Column (Left) */}
                        <div className="col-12 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="d-flex justify-content-center align-items-center h-100">
                                <img
                                    className="img-fluid"
                                    src="/img/About/about.webp"  // <-- Change owner image path here
                                    alt="Owner"
                                    style={{
                                        width: "100%",          // Editable
                                        height: "600px",        // Editable
                                        objectFit: "cover",
                                        borderRadius: "12px",
                                        backgroundColor: "#f8f9fa"
                                    }}
                                />
                            </div>
                        </div>

                        {/* Text Column (Right) */}
                        <div className="col-12 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="h-100">
                                <p className="text-uppercase mb-2" style={{ color: "#000000ff" }}>Meet the Photographer & Cinematographer Behind the Brand</p>
                                <h1 className="display-6 mb-4">Anil Pandey</h1>

                                <p>
                                    the creative mind behind Well Captured Hub, is a passionate wedding and pre-wedding photographer & cinematographer dedicated to preserving love stories through timeless visuals. With years of professional experience in the wedding industry, he has mastered the art of capturing genuine emotions, meaningful moments, and cinematic memories that couples cherish for a lifetime.
                                </p>

                                <p>
                                    Known for his creative vision, attention to detail, and storytelling approach, Anil seamlessly blends candid photography with cinematic filmmaking to create wedding albums and films that are both elegant and emotional. From intimate pre-wedding sessions to grand wedding celebrations, every frame is thoughtfully crafted to reflect the unique bond, personality, and journey of each couple.
                                </p>

                                <p>
                                    Over the years, Anil has had the privilege of documenting countless weddings and pre-wedding stories, earning the trust of couples through his professionalism, creativity, and commitment to excellence. Every celebration he captures is approached with passion, precision, and a genuine desire to transform fleeting moments into everlasting memories that can be relived for generations.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


                {/* NEW Services Section (Same UI as What We Do + NavLink Title) */}
                <div
                    className="services-section"
                    style={{
                        backgroundColor: "#ffffff",
                        padding: "100px 20px",
                        textAlign: "center"
                    }}
                >
                    <div
                        className="container"
                        style={{
                            maxWidth: "900px",
                            margin: "0 auto"
                        }}
                    >

                        {/* Top Divider */}
                        <div className="elementor-divider">
                            <span
                                className="elementor-divider-separator"
                                style={{
                                    display: "block",
                                    borderTop: "1px solid rgba(0,0,0,0.3)",
                                    margin: "0 auto 20px",
                                    width: "60%"
                                }}
                            ></span>
                        </div>

                        {/* Title with NavLink */}
                        <NavLink
                            to="/Services"
                            style={{
                                textDecoration: "none",
                                color: "#000",
                            }}
                            className="service-title-link"
                        >
                            <h2
                                style={{
                                    fontSize: "42px",
                                    fontWeight: 700,
                                    marginBottom: "20px",
                                    cursor: "pointer"
                                }}
                            >
                                Our Services
                            </h2>
                        </NavLink>

                        {/* Bottom Divider */}
                        <div className="elementor-divider">
                            <span
                                className="elementor-divider-separator"
                                style={{
                                    display: "block",
                                    borderTop: "1px solid rgba(0,0,0,0.3)",
                                    margin: "20px auto 40px",
                                    width: "60%"
                                }}
                            ></span>
                        </div>

                        {/* Description */}
                        <p
                            style={{
                                fontSize: "18px",
                                lineHeight: "1.7",
                                color: "rgba(0,0,0,0.75)"
                            }}
                        >
                            Explore our wide range of wedding and pre-wedding photography services, crafted with creativity, precision, and heartfelt storytelling. From dreamy pre-wedding shoots to beautifully curated wedding day coverage, we capture every moment with artistic detail and emotional depth turning your memories into timeless treasures.
                        </p>

                    </div>
                </div>


                {/* Testimonial Start */}
                <div
                    className="testimonial-section"
                    style={{
                        backgroundImage: "url('/img/About/Testimonials.webp')", // change to your BG
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        padding: '120px 20px',
                        position: 'relative',
                        color: '#fff',
                    }}
                >
                    {/* Dark overlay */}
                    <div
                        style={{
                            position: "absolute",
                            inset: 0,
                            backgroundColor: "rgba(0,0,0,0.55)",
                        }}
                    ></div>

                    <div
                        className="container"
                        style={{
                            position: "relative",
                            zIndex: 2,
                            maxWidth: "900px",
                            textAlign: "center"
                        }}
                    >

                        {/* Top Divider */}
                        <div className="elementor-divider">
                            <span
                                className="elementor-divider-separator"
                                style={{
                                    display: "block",
                                    borderTop: "1px solid rgba(255,255,255,0.4)",
                                    margin: "0 auto 20px",
                                    width: "60%"
                                }}
                            ></span>
                        </div>

                        {/* Title */}
                        <h2
                            style={{
                                fontSize: "42px",
                                fontWeight: "700",
                                marginBottom: "10px",
                                color: "#fff"
                            }}
                        >
                            Testimonials
                        </h2>

                        {/* Stars */}
                        <div style={{ marginBottom: "20px" }}>
                            <i className="fas fa-star text-warning mx-1"></i>
                            <i className="fas fa-star text-warning mx-1"></i>
                            <i className="fas fa-star text-warning mx-1"></i>
                            <i className="fas fa-star text-warning mx-1"></i>
                            <i className="fas fa-star text-warning mx-1"></i>
                        </div>

                        {/* Bottom Divider */}
                        <div className="elementor-divider">
                            <span
                                className="elementor-divider-separator"
                                style={{
                                    display: "block",
                                    borderTop: "1px solid rgba(255,255,255,0.4)",
                                    margin: "0 auto 30px",
                                    width: "60%"
                                }}
                            ></span>
                        </div>

                        {/* Testimonial Slider */}
                        <Swiper
                            modules={[Navigation, Autoplay]}
                            autoplay={{ delay: 3000, disableOnInteraction: false }}
                            loop={true}
                            slidesPerView={1}
                            navigation={false}
                            spaceBetween={30}
                            speed={700}   // smooth slide
                            style={{ paddingBottom: "20px" }}
                        >
                            {[
                                {
                                    name: "Vidhi Patel",
                                    text: "I highly recommend the work of photographer Anilbhai & Team...",
                                },
                                {
                                    name: "Nidhi Mishra",
                                    text: "Excellence in every aspect. Thank you Anil ji for capturing beautiful memories...",
                                },
                                {
                                    name: "Parth Patel",
                                    text: "Great work. Very cooperative staff and creative photography...",
                                },
                            ].map((review, index) => (
                                <SwiperSlide key={index}>
                                    <p
                                        style={{
                                            fontSize: "20px",
                                            color: "rgba(255,255,255,0.9)",
                                            lineHeight: "1.7",
                                            marginBottom: "20px"
                                        }}
                                    >
                                        {review.text}
                                    </p>

                                    <h4
                                        style={{
                                            fontSize: "20px",
                                            letterSpacing: "2px",
                                            color: "#fff"
                                        }}
                                    >
                                        {review.name}
                                    </h4>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>

                <Footer />
            </div>
        </>
    )

}

export default Home
